import React, { useEffect, useState } from 'react'
import './CourseModule.css'
import { useNavigate, useParams } from 'react-router';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { message, Progress, Spin } from 'antd';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import QuizIcon from '@mui/icons-material/Quiz';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import axios from 'axios';
import { BaseUrl } from '../../Constants/Constants';
import ArticleIcon from '@mui/icons-material/Article';
import { useStateValue } from '../../../Reducer/reducer';

const CourseModule = () => {

    const [courseName, setCourseName] = useState("");
    const [expanded, setExpanded] = React.useState(false);
    const [expandedAss, setExpandedAss] = React.useState(false);
    const [courseModule, setCourseModule] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Assesment, setAssesment] = useState('')
     const [
        { UserID, companyId },
        dispatch,
      ] = useStateValue();

    const navigate = useNavigate();

    const profileDetails = JSON.parse(localStorage.getItem('Profile'));
    const UserId = profileDetails.user_id;

    console.log(courseModule, 'courseModule')

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleAssessmentAccordion = (panel) => (event, isExpanded) => {
        setExpandedAss(isExpanded ? panel : false);
    };

    const { id } = useParams();


    useEffect(() => {

        setLoading(true);

        let body = {
            courseId: id
        }

        axios.post(`${BaseUrl}courses/findOne`, body, { withCredentials: true })

            .then((res) => {

                let response = res.data;

                if (response.statuscode === 200) {
                    console.log(res.data.data[0], 'courseDetails');
                    setCourseName(response.data[0].course_title);
                }
                else {
                    setCourseName('');
                }
            })
            .catch((err) => {
                console.log(err.message)
            })


            let body2={
                courseId: id,
                userId: UserId
            }
        axios.post(`${BaseUrl}course-parts/findOneByCourseId`, body2, { withCredentials: true })
            .then((res) => {
                let response = res.data
                console.log(response.data, 'findOneByCourseId');

                if (response.statuscode === 200) {
                    setCourseModule(response.data);
                }

            })
            .catch((err) => {
                console.log(err.message)
                // setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            })


        let trackerBody = {
            userId: UserId
        }

        axios.post(`${BaseUrl}course-tracker/getAllCourseTrackerByUserId`, trackerBody, { withCredentials: true })
            .then((res) => {
                console.log(res.data, 'trackerResp')
            })

    }, [])

 const handleAsessmentClick=(item)=>{

             axios
  .get(`${BaseUrl}assessment-score/check-eligibility`, {
             params: {
                 // Send the parameters in the 'params' key for GET requests
                 userId: UserID,
                 courseId: id,
             },
             withCredentials: true,
         })
                 .then((res) => {
                     if (res?.data?.isEligible=='Pass'){
                       message.success("You've Successfully Completed this course")
                     }
                     else{
                           navigate(`/courses/${id}/assessment/${item.Assesment_id}`);
                     }
                   
                 })
                 .catch((err) => {
                     message.error(err.message);
                 })
                 .finally((res) => {
     
                 })
 
 }



    useEffect(() => {
        let body = {
            course_id: id
        }
        axios
            .post(`${BaseUrl}assesment/list_of_assessments`, body, { withCredentials: true })
            .then((res) => {
                setAssesment(res.data.data)
                console.log(res.data.data, "listOfAssessments")
            })
            .catch((err) => {
                message.error(err.message);
            })
            .finally((res) => {

            })
    }, [])






    const assessmentData = [
        {
            icon: <EditNoteOutlinedIcon />,
            testName: `${courseName} assessment`,
            marks: "9/10",
            status: <CheckCircleOutlineOutlinedIcon />
        }
    ]






    return (
        <div className='courseModuleMainDiv'>
            {/* Breadcrumb Navigation */}
            <div className='courseBreadcrumb'>
                <span className='breadcrumbLink' onClick={(e) => navigate(`/courses`)}>
                    Courses
                </span>
                <ArrowForwardIosIcon className='breadcrumbArrow' />
                {courseName && (
                    <span className='breadcrumbCurrent'>
                        {courseName}
                    </span>
                )}
            </div>

            {loading ? (
                <div className='courseLoader'>
                    <Spin size="large" />
                </div>
            ) : (
                <>
                    {/* Course Header */}
                    <div className='courseHeader'>
                        <div className='courseIconWrapper'>
                            <MenuBookIcon className='courseHeaderIcon' />
                        </div>
                        <div className='courseHeaderContent'>
                            <h1 className='courseTitle'>{courseName}</h1>
                            <p className='courseSubtitle'>Explore course modules and enhance your learning journey</p>
                        </div>
                    </div>

                    {/* Course Modules Section */}
                    {courseModule.length > 0 && (
                        <div className='courseModulesSection'>
                            <div className='sectionHeader'>
                                <AutoAwesomeIcon className='sectionIcon' />
                                <h2 className='sectionTitle'>Course Modules</h2>
                            </div>
                            <div className='coursesAccordion'>
                                {courseModule.map((item, key) => {
                                    const isLastPart = key === courseModule.length - 1;
                                    const isOnlyPart = courseModule.length === 1;
                                    return (
                                        <Accordion 
                                            key={key}
                                            expanded={expanded === `panel${key}`} 
                                            onChange={handleChange(`panel${key}`)}
                                            className='modernAccordion'
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon className='expandIcon' />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                                className='accordionSummary'
                                            >
                                                <div className='accordionHeaderContent'>
                                                    <div className='partNumberBadge'>{item.partNumber || key + 1}</div>
                                                    <div className='accordionHeadingWrapper'>
                                                        <p className='accordionHeading'>
                                                            {item.partNumber && item.partTitle 
                                                                ? `${item.partNumber} - ${item.partTitle}` 
                                                                : item.partTitle || `Part ${key + 1}`
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails className='accordionDetails'>
                                                <div className='courseSourceDiv'>
                                                    {item.training.map((e, k) => (
                                                        <div
                                                            key={k}
                                                            onClick={() => {
                                                               navigate(
                                                            `/courses/${id}/pages/${e.id}${
                                                                item.partId ? `?partId=${item.partId}` : ""
                                                            }`
                                                            );
                                                            }}
                                                            className='courseItemCard'
                                                        >
                                                            <div className='courseItemContent'>
                                                                <div className={`courseItemIcon ${e.type === 'mp4' ? 'videoIcon' : 'documentIcon'}`}>
                                                                    {e.type === 'mp4' ? (
                                                                        <PlayCircleOutlinedIcon />
                                                                    ) : (
                                                                        <ArticleIcon />
                                                                    )}
                                                                </div>
                                                                <div className='courseItemInfo'>
                                                                    <p className='courseItemName'>{e.name}</p>
                                                                    <div className='courseItemMeta'>
                                                                        {e.type === 'mp4' && e.time && (
                                                                            <span className='courseItemTime'>
                                                                                <AccessTimeIcon className='timeIcon' />
                                                                                {e.time}
                                                                            </span>
                                                                        )}
                                                                        <span className={`courseItemType ${e.type === 'mp4' ? 'typeVideo' : 'typeDocument'}`}>
                                                                            {e.type === 'mp4' ? 'Video' : 'Document'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {e.isLearning &&(
                                                                <div className='courseItemProgress'>
                                                                <Progress 
                                                                    type="circle" 
                                                                    percent={100} 
                                                                    width={40}
                                                                    strokeColor={{
                                                                        '0%': '#667eea',
                                                                        '100%': '#764ba2',
                                                                    }}
                                                                    showInfo={false}
                                                                />
                                                                <CheckCircleOutlineOutlinedIcon className='completedIcon' />
                                                            </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Assessment Section */}
                    {Assesment.length !== 0 && (
                        <div className='assessmentSection'>
                            <div className='sectionHeader'>
                                <QuizIcon className='sectionIcon assessmentSectionIcon' />
                                <h2 className='sectionTitle'>Assessments</h2>
                            </div>
                            <div className='assessmentAccordion'>
                                <Accordion className='modernAccordion assessmentAccordionItem'>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon className='expandIcon' />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='accordionSummary'
                                    >
                                        <div className='accordionHeaderContent'>
                                            <div className='partNumberBadge assessmentBadge'>
                                                <QuizIcon />
                                            </div>
                                            <p className='accordionHeading'>Click here to take the assessment!</p>
                                        </div>
                                    </AccordionSummary>
                                    {Assesment.map((item, key) => (
                                        <AccordionDetails key={key} className='accordionDetails'>
                                            <div 
                                                onClick={() => handleAsessmentClick(item)}
                                                className='assessmentItemCard'
                                            >
                                                <div className='assessmentItemContent'>
                                                    <div className='assessmentItemIcon'>
                                                        <EditNoteOutlinedIcon />
                                                    </div>
                                                    <div className='assessmentItemInfo'>
                                                        <p className='assessmentItemName'>{item.Assessment_name}</p>
                                                        <span className='assessmentItemHint'>Click to start assessment</span>
                                                    </div>
                                                </div>
                                                <ArrowForwardIosIcon className='assessmentArrow' />
                                            </div>
                                        </AccordionDetails>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default CourseModule